var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import productBouquetActions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import { useSelector } from "react-redux";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
import { useEffect, useState } from "react";
import { EBuySell } from "@frameworks/NCD/Enum/OTC";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import { useLocation } from "react-router-dom";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
var useTransactionHandler = function () {
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.LoginType);
    var _a = __read(useState(false), 2), showPartnerLeadCreationModal = _a[0], setShowPartnerLeadCreationModal = _a[1];
    var location = useLocation();
    var searchParams = new URLSearchParams(location.search);
    var _b = __read(useState({
        isShow: false,
        isError: false,
        msg: "",
    }), 2), toastDetails = _b[0], setToastDetails = _b[1];
    var isSaveProduct = location.pathname
        .toLowerCase()
        .includes("saved-products");
    var cActions = new actions();
    var _c = __read(useState(false), 2), viewOrders = _c[0], setViewOrders = _c[1];
    var cProductBouquetActions = new productBouquetActions();
    var _d = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), watchListRequestPayload = _d.watchListRequestPayload, userPopupStatus = _d.userPopupStatus;
    var transactionVisible = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).transactionVisible;
    var handleUpdateTransactionPopupState = function (state) {
        cActions.updateTransactionVisible(state);
    };
    useEffect(function () {
        var schemeId = searchParams.get("schemeid");
        var isin = searchParams.get("isin");
        if (schemeId !== "" &&
            schemeId !== null &&
            schemeId !== undefined &&
            isin !== "" &&
            isin !== null &&
            isin !== undefined &&
            (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg)) {
            otcDi.productBouquet
                .getProductDetails({
                isin_code: isin,
                tab_id: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.tab_id,
                buysell_flg: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                    ? EBuySellFlag.BUY
                    : EBuySellFlag.SELL,
            })
                .then(function (response) {
                if ((response === null || response === void 0 ? void 0 : response.data) !== null && (response === null || response === void 0 ? void 0 : response.data)) {
                    var productDetail = response === null || response === void 0 ? void 0 : response.data;
                    var tableRowData = {
                        ncdName: productDetail === null || productDetail === void 0 ? void 0 : productDetail.display_name,
                        isin: productDetail === null || productDetail === void 0 ? void 0 : productDetail.isin_code,
                        rating: productDetail === null || productDetail === void 0 ? void 0 : productDetail.rating,
                        payoutFreq: productDetail === null || productDetail === void 0 ? void 0 : productDetail.interest_frequency,
                        priceRange: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? productDetail === null || productDetail === void 0 ? void 0 : productDetail.price_range_buy
                            : productDetail === null || productDetail === void 0 ? void 0 : productDetail.price_range,
                        availableQty: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? String(productDetail === null || productDetail === void 0 ? void 0 : productDetail.virtual_buy_qty)
                            : String(productDetail === null || productDetail === void 0 ? void 0 : productDetail.avl_qty),
                        couponRate: productDetail === null || productDetail === void 0 ? void 0 : productDetail.coupon_rate,
                        isin_id: productDetail === null || productDetail === void 0 ? void 0 : productDetail.isin_id,
                        min_sell_price: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? String(productDetail === null || productDetail === void 0 ? void 0 : productDetail.buy_price_min)
                            : String(productDetail === null || productDetail === void 0 ? void 0 : productDetail.min_sell_price),
                        dirty_price: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? Number(productDetail === null || productDetail === void 0 ? void 0 : productDetail.dirty_price_buy)
                            : Number(productDetail === null || productDetail === void 0 ? void 0 : productDetail.min_sell_price),
                        max_sell_price: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? String(productDetail === null || productDetail === void 0 ? void 0 : productDetail.buy_price_max)
                            : String(productDetail === null || productDetail === void 0 ? void 0 : productDetail.max_sell_price),
                        buySellFlag: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? EBuySell.Buy
                            : EBuySell.Sell,
                    };
                    cActions.updateTransactionDetails(__assign(__assign({}, tableRowData), { availableQty: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? productDetail === null || productDetail === void 0 ? void 0 : productDetail.virtual_buy_qty
                            : productDetail === null || productDetail === void 0 ? void 0 : productDetail.avl_qty }));
                    cActions.updateTransactionVisible(true);
                    setToastDetails({
                        isShow: false,
                        isError: false,
                        msg: "",
                    });
                }
                else {
                    setToastDetails({
                        isShow: true,
                        isError: true,
                        msg: "ISIN code is incorrect and there is no data related to it.",
                    });
                }
            });
        }
    }, [watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg]);
    var handleTransactionClick = function (keysForCustomFunction, e) { return __awaiter(void 0, void 0, void 0, function () {
        var tableRowData, res;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    e === null || e === void 0 ? void 0 : e.stopPropagation();
                    tableRowData = {
                        ncdName: keysForCustomFunction[0],
                        isin: keysForCustomFunction[1],
                        rating: keysForCustomFunction[2],
                        payoutFreq: keysForCustomFunction[3],
                        priceRange: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? keysForCustomFunction[17]
                            : keysForCustomFunction[4],
                        availableQty: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? String(keysForCustomFunction[14])
                            : String(keysForCustomFunction[5]),
                        couponRate: keysForCustomFunction[6],
                        isin_id: keysForCustomFunction[7],
                        min_sell_price: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? String(keysForCustomFunction[15])
                            : String(keysForCustomFunction[8]),
                        dirty_price: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? Number(keysForCustomFunction[13])
                            : Number(keysForCustomFunction[10]),
                        max_sell_price: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? String(keysForCustomFunction[16])
                            : String(keysForCustomFunction[11]),
                        buySellFlag: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? EBuySell.Buy
                            : EBuySell.Sell,
                        entity: String(keysForCustomFunction[19]),
                    };
                    if (!(partnerCategory == ILoginTypeEnum.PARTNER)) return [3 /*break*/, 1];
                    tableRowData = __assign(__assign({}, tableRowData), { trx_id: (_a = keysForCustomFunction[9]) !== null && _a !== void 0 ? _a : null });
                    cActions.updateTransactionDetails(tableRowData);
                    setShowPartnerLeadCreationModal(true);
                    return [3 /*break*/, 6];
                case 1:
                    if (isSaveProduct) {
                        cProductBouquetActions.updateSubCategoryId(keysForCustomFunction[18]);
                    }
                    if (!!(userPopupStatus === null || userPopupStatus === void 0 ? void 0 : userPopupStatus.data)) return [3 /*break*/, 2];
                    cProductBouquetActions.updateOnBoardPopup(true);
                    tableRowData = __assign(__assign({}, tableRowData), { trx_id: (_b = Number(keysForCustomFunction[9])) !== null && _b !== void 0 ? _b : null });
                    cActions.updateTransactionDetails(tableRowData);
                    return [3 /*break*/, 6];
                case 2:
                    cActions.updateTransactionVisible(true);
                    tableRowData = __assign({}, tableRowData);
                    cActions.updateTransactionDetails(tableRowData);
                    if (!Number(keysForCustomFunction[9])) return [3 /*break*/, 4];
                    return [4 /*yield*/, cActions.updateTransactionId(Number(keysForCustomFunction[9]))];
                case 3:
                    _e.sent();
                    setViewOrders(false);
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, otcDi.productBouquet.getProductDetails({
                        isin_code: keysForCustomFunction[1],
                        tab_id: watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.tab_id,
                        buysell_flg: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? EBuySellFlag.BUY
                            : EBuySellFlag.SELL,
                    })];
                case 5:
                    res = _e.sent();
                    cActions.updateTransactionDetails(__assign(__assign({}, tableRowData), { availableQty: (watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                            ? (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.virtual_buy_qty
                            : (_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.avl_qty }));
                    _e.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    return {
        transactionVisible: transactionVisible,
        handleTransactionClick: handleTransactionClick,
        handleUpdateTransactionPopupState: handleUpdateTransactionPopupState,
        viewOrders: viewOrders,
        setViewOrders: setViewOrders,
        setShowPartnerLeadCreationModal: setShowPartnerLeadCreationModal,
        showPartnerLeadCreationModal: showPartnerLeadCreationModal,
    };
};
export default useTransactionHandler;
